import request from '@/utils/request'

/* member player */
export function addPlayer(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddPlayer.json',
    method: 'post',
    data
  })
}

export function updatePlayer(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdatePlayer.json',
    method: 'post',
    data
  })
}

export function deletePlayer(id) {
  const data = {
    userId: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/DeletePlayer.json',
    method: 'post',
    data
  })
}

export function getPlayerById(id) {
  const params = {
    id: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetPlayer.json',
    method: 'get',
    params
  })
}

export function getPlayerList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetPlayerList.json',
    method: 'post',
    params
  })
}

// 监护人jsonarray[{id,name,mobile,email,address,work,relation},..]
export function updatePlayerGuardian(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdatePlayerGuardian.json',
    method: 'post',
    data
  })
}

export function GetPlayersYearsList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayersYearsList.json',
    method: 'get',
    params
  })
}
export function GetPlayerYearsList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerYearsList.json',
    method: 'get',
    params
  })
}
export function GetPlayerGamesDataList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerGamesDataList.json',
    method: 'get',
    params
  })
}
export function GetPlayerMatchesDataList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerMatchesDataList.json',
    method: 'get',
    params
  })
}
export function GetPlayerTeamsDataList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerTeamsDataList.json',
    method: 'get',
    params
  })
}

export function getPlayerExtendedInfo(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/players/info',
        method: 'get',
        params
    }) 
}

export function getPlayerSchoolList(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/players/schools',
        method: 'get',
        params
    }) 
}

export function addSchoolRelation(data) {
  const params = Object.assign({}, {accessKey: 'bjh-admin-rpes'})
  return request({
    url: process.env.BJH_STATS_API + '/api/rpes/player_school/',
    method: 'post',
    data,
    params
  })
}

export function removeSchoolRelation(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_school/',
        method: 'delete',
        params
    }) 
}

export function addSchoolRelationChange(data) {
  const params = Object.assign({}, {accessKey: 'bjh-admin-rpes'})
  return request({
    url: process.env.BJH_STATS_API + '/api/rpes/player_school_change/',
    method: 'post',
    data,
    params
  })
}

export function getSchoolRelationChangeList(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/players/changes',
        method: 'get',
        params
    }) 
}

export function getPlayerOrganizationList(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/players/organizations',
        method: 'get',
        params
    }) 
}

export function addOrganizationRelation(data) {
  const params = Object.assign({}, {accessKey: 'bjh-admin-rpes'})
  return request({
    url: process.env.BJH_STATS_API + '/api/rpes/player_organization/',
    method: 'post',
    data,
    params
  })
}

export function removeOrganizationRelation(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/player_organization/',
        method: 'delete',
        params
    }) 
}

export function updateUserInfo(params, data) {
  params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
  return request({
    url: process.env.BJH_STATS_API + '/api/rpes/passport_user/',
    method: 'put',
    data,
    params
  })
}

export function updatePlayerInfo(params, data) {
  params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
  return request({
    url: process.env.BJH_STATS_API + '/api/rpes/player/',
    method: 'put',
    data,
    params
  })
}

export function getPlayerMatchGroupList(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/players/groups',
        method: 'get',
        params
    }) 
}

export function getMembershipStatus(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    params.ts = Math.random()
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/membership/status',
        method: 'get',
        params
    }) 
}